import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarPedidosExcel`, method: 'POST', body: value, token: token})
}
